export default __webpack_public_path__ + "static/media/GameWithRedDot.b41ce551.svg";